/**
 * Server time synchronisation.
 *
 * Calculates a one-time offset between the server clock (venue timezone) and
 * the device clock on app load. Every subsequent call to getCorrectedNow()
 * costs only a single integer addition — no network, no heavy math.
 *
 * If the server time is never provided (offline load, fallback path),
 * the offset stays at 0 and device time is used as-is.
 */

let _offsetMs = 0;

/**
 * Call once after receiving serverDateTime from /api/config.
 * @param {string} serverIsoString - ISO 8601 datetime string from the backend (venue timezone).
 */
export function syncServerTime(serverIsoString) {
    if (!serverIsoString) return;
    const serverMs = new Date(serverIsoString).getTime();
    if (!Number.isFinite(serverMs)) return;
    _offsetMs = serverMs - Date.now();
}

/**
 * Returns a Date representing "now" corrected for any device clock drift.
 * Falls back to device time if syncServerTime was never called.
 */
export function getCorrectedNow() {
    return new Date(Date.now() + _offsetMs);
}
